import axios from 'axios'
// axios.defaults.baseURL = '/api'
// import store from '@/store/index.js'
// import baseURL from './baseUrl'
import router from '@/router/index'
import {
    Message,
    Loading
} from 'element-ui'
const http = {}
function toProxyLogin() {
    router.push({
        path: 'ProxyLogin',
        query: {
            plan: 'private'
        }
    })
}
// console.log(Message)
// const instance = axios.create({
//     baseURL: 'url'
// })
// var instance = axios.create({
//     timeout: 5000,
//     baseURL,
//     validatecode(code) {
//         switch (code) {
//         case 400:
//             Message.error('请求出错')
//             break
//         case 401:
//             Message.warning({
//                 message: '授权失败，请重新登录'
//             })
//             store.commit('LOGIN_OUT')
//             setTimeout(() => {
//                 window.location.reload()
//             }, 1000)
//             return
//         case 403:
//             Message.warning({
//                 message: '拒绝访问'
//             })
//             break
//         case 404:
//             Message.warning({
//                 message: '请求错误,未找到该资源'
//             })
//             break
//         case 500:
//             Message.warning({
//                 message: '服务端错误'
//             })
//             break
//         }
//         return code >= 200 && code < 300
//     }
// })

// // 添加请求拦截器
// instance.interceptors.request.use(
//     function(config) {
//         // 请求头添加token
//         if (store.state.UserToken) {
//             config.headers.Authorization = `Bearer ${store.state.UserToken}`
//         }
//         return config
//     },
//     function(error) {
//         return Promise.reject(error)
//     }
// )
function clearAllCookie() {
    var date = new Date();
    date.setTime(date.getTime() - 10000);
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    console.log("需要删除的cookie名字：" + keys);
    if (keys) {
        for (var i = keys.length; i--;)
            document.cookie = keys[i] + "=0; expire=" + date.toGMTString() + "; path=/";
    }
}

function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
}

function getUrlParams(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let param = window.location.search.substr(1).match(reg);
    return param && param[2];
}

function proxyLogin(to, from, token, next) {
    let _this = this
    let url = window.location.href;
    token = getUrlParams('HncToken')
    let returnURL = ''
    //解决地址栏输入影子系统地址，但是登录上去却是正式环境的系统
    if (to && to.query && to.query.returnURL) {
        returnURL = to.query.returnURL
        alert(returnURL);
    } else {
        // 创建URL对象
        let urlObj = new URL(url);
        // 使用URLSearchParams获取参数
        let searchParams = new URLSearchParams(urlObj.search);
        // 获取returnURL参数的值
        let returnURL2 = searchParams.get('returnURL');
        if (returnURL2) {
            returnURL = returnURL2;
        }
    }
    console.log(to);
    console.log(url, token)
    http.get('/api/common/organizationstructure/user/proxylogin', true, { returnURL }, function (res) {
        console.log(res);
        let data = res.data.data
        $.getJSON(data.askurl + "?callback=?", {
                askData: data.askData,
                HncToken: token ? token : '',
                switchboard_identity_id: '',
                appDomain: data.appDomain,
            },
            function (d) {
                console.log(d)
                if (d.status == false) {
                    if ("没有获取到token" == d.msg || "根据token没有获取用户信息" == d.msg) {} else {
                        alert(d.msg);
                    }
                    clearAllCookie()
                    window.location.href = data.redirectLoginUrl;
                } else {
                    http.get('/api/common/organizationstructure/user/oklogin', false, {
                        token: d.msg,
                        HncToken: d.msg,
                        switchboard_identity_id: d.obj,
                        returnURL: data.returnURL
                    }, function (res) {
                        if (res.data.status) {
                            location.reload();
                            if (next) {
                                next()
                                // localStorage.setItem('token', d.msg)
                            }
                        } else {
                            alert(res.msg);
                            window.location.href = res.redirectLogoutUrl;
                        }
                    })
                }
            })
    })
}

http.get = function (url, useToken = false, params, _sussess, _fail, other202 = false, maskLoading = true) {
    Message.closeAll()
     let loadingInstance
    if(!params?.isHideLoading){
        loadingInstance = maskLoading ? Loading.service({
            fullscreen: true,
            background: 'rgba(0, 0, 0, .7)'
        }) : null;
    }
    
    params = params || {}
    _sussess ? _sussess : null
    _fail ? _fail : null
    axios({
            method: "get",
            url: url,
            params: params
        }).then(res => {
            // console.log(1)
            if (maskLoading && loadingInstance) {
                loadingInstance.close();    
            }
            
            if (res.status) {
                if (res.data.code == 200) { //正确返回数据
                    _sussess(res)
                } else if (res.data.code == 499) {
                    proxyLogin()
                } else {
                    if (res.data.code == 204) {
                        Message.error(res.data.msg);
                        localStorage.clear();
                        router.push('/login')
                    } else {
                        if (res.data.code == 202 && other202) { //goodsList页面接口需要other202=true
                            _fail(res)
                        } else {
                            Message({
                                showClose: true,
                                message: res.data.msg,
                                type: 'error',
                                duration: 50000
                            });
                        }
                    }
                }
            } else {
                Message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                    duration: 50000
                });
            }
        })
        .catch(err => {
            console.log(err)
            if (maskLoading && loadingInstance) {
                loadingInstance.close();    
            }
            alert(err);
        })
}

http.post = function (url, useToken = false, params, _sussess, _fail, method = "post",isData = false) {
    Message.closeAll()

    let loadingInstance = Loading.service({
        fullscreen: true,
        background: 'rgba(0, 0, 0, .7)'
    });
    params = params || {}
    _sussess ? _sussess : null
    _fail ? _fail : null
    let obj = {
        method: method,
        url: url,
    }
    if (isData) {
        obj.data = params
    } else {
        obj.params = params
    }
    // if (useToken) {
    //     let token = localStorage.getItem('token')
    //     params.HncToken = token
    // }
    axios(obj).then(res => {
            loadingInstance.close();
            if (res.status) {
                if (res.data.code == 200) { //正确返回数据
                    console.log(res)
                    // console.log(args._sussess)
                    _sussess(res)
                } else if (res.data.code == 499) {
                    proxyLogin()
                } else {
                    if (res.data.code == 204) {
                        Message.error(res.data.msg);
                        localStorage.clear();
                        router.push('/login')
                    } else {
                        Message({
                            showClose: true,
                            message: res.data.msg,
                            type: 'error',
                            duration: 50000
                        });
                    }
                }
            } else {
                Message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                    duration: 50000
                });
                // console.log(res)
                //  Message.error({
                //      showClose: true,
                //      message: res.data.msg
                //  });
                // Message.error(res.data.msg);
            }
        })
        .catch(err => {
            loadingInstance.close();
            alert(err);
            // console.log(err)
        })
}


http.put = function (url, useToken = false, params, _sussess, _fail, method = "put", isData = false) {
    Message.closeAll()
    let loadingInstance = Loading.service({
        fullscreen: true,
        background: 'rgba(0, 0, 0, .7)'
    });
    params = params || {}
    _sussess ? _sussess : null
    _fail ? _fail : null
    let obj = {
        method: method,
        url: url,
    }
    if (isData) {
        obj.data = params
    } else {
        obj.params = params
    }
    axios(obj).then(res => {
            loadingInstance.close();
            if (res.status == 200) {
                if (res.data.code == 200) { //正确返回数据
                    _sussess(res)
                } else if (res.data.code == 499) {
                    proxyLogin()
                } else {
                    if (res.data.code == 204) {
                        Message.error(res.data.msg);
                        localStorage.clear();
                        router.push('/login')
                    } else {
                        Message({
                            showClose: true,
                            message: res.data.msg,
                            type: 'error',
                            duration: 50000
                        });
                    }
                }
            } else {
                Message.error({
                    showClose: true,
                    message: res.data.msg
                });
            }
        })
        .catch(err => {
            loadingInstance.close();
            alert(err);
        })
}

http.delete = function (url, useToken = false, params, _sussess, _fail, method = "delete") {
    Message.closeAll()
    let loadingInstance = Loading.service({
        fullscreen: true,
        background: 'rgba(0, 0, 0, .7)'
    });
    let msg 
    params = params || {}
    _sussess ? _sussess : null
    _fail ? _fail : null
    // if (useToken) {
    //     let token = localStorage.getItem('token')
    //     params.HncToken = token
    // }
    axios({
            method: method,
            url: url,
            params: params
        }).then(res => {
            msg = res.data.msg
            loadingInstance.close();
            if (res.status == 200) {
                if (res.data.code == 200) { //正确返回数据
                    _sussess(res)                   
                } else if (res.data.code == 499) {
                    proxyLogin()
                } else {
                    if (res.data.code == 204) {
                        Message.error(res.data.msg);
                        localStorage.clear();
                        router.push('/login')
                    } else {
                        _sussess(res)
                    }
                }
            } else {
                Message.error({
                    showClose: true,
                    message: res.data.msg
                });
            }
        })
        .catch(err => {
            loadingInstance.close();
            // alert(msg)            
            Message.error(msg);
        })
}

// http.get = function(url, useToken, options) {
//     let loading
//     if (!options || options.isShowLoading !== false) {
//         loading = document.getElementById('ajaxLoading')
//         loading.style.display = 'block'
//     }
//     return new Promise((resolve, reject) => {
//         instance
//             .get(url, options)
//             .then(response => {
//                 if (!options || options.isShowLoading !== false) {
//                     loading = document.getElementById('ajaxLoading')
//                     loading.style.display = 'none'
//                 }
//                 if (response.code === 1) {
//                     resolve(response.data)
//                 } else {
//                     Message.error({
//                         message: response.msg
//                     })
//                     reject(response.msg)
//                 }
//             })
//             .catch(e => {
//                 console.log(e)
//             })
//     })
// }

// http.post = function(url, data, options) {
//     let loading
//     if (!options || options.isShowLoading !== false) {
//         loading = document.getElementById('ajaxLoading')
//         loading.style.display = 'block'
//     }
//     return new Promise((resolve, reject) => {
//         instance
//             .post(url, data, options)
//             .then(response => {
//                 if (!options || options.isShowLoading !== false) {
//                     loading = document.getElementById('ajaxLoading')
//                     loading.style.display = 'none'
//                 }
//                 if (response.code === 1) {
//                     resolve(response.data)
//                 } else {
//                     Message.error({
//                         message: response.msg
//                     })
//                     reject(response.message)
//                 }
//             })
//             .catch(e => {
//                 console.log(e)
//             })
//     })
// }

export default http